import { createSelector } from '@reduxjs/toolkit';

import Subscription from '../models/subscriptions';
import type { RootState } from '../reducers';
import { getPrenumerationSubscriptions } from '../utils/reselectors';
import { getCurrentListPage } from './list';

export const getAdvertisementSubscriptions = createSelector(
  (state: RootState) => state.subscriptions.advertisement.list,
  (subscriptions) =>
    (subscriptions || []).map(Subscription.parseAdvertisementSubscription).sort((a, b) => {
      if (a.isActive && !b.isActive) {
        return -1;
      }
      if (!a.isActive && b.isActive) {
        return 1;
      }

      return 0;
    }),
);

export const getSubscription = (state: RootState, slug: string) => {
  const list = getCurrentListPage(state, slug);
  const subscriptions = getPrenumerationSubscriptions(state);
  if (list && subscriptions) {
    const subscription = subscriptions.find((x) => x.referenceId === list.id);
    if (subscription) return subscription;
  }
  return null;
};

export const isAdvertiesementSubscriptionsSynced = (state: RootState) =>
  state.subscriptions.advertisement.synced;

export const getAdvertisementSubscriptionById = createSelector(
  getAdvertisementSubscriptions,
  (_: RootState, id?: string | null) => id,
  (subscriptions, id) => {
    if (!id || subscriptions.length === 0) {
      return null;
    }

    const result = subscriptions.find((s) => s.advertisementId === id);
    return result ? result : null;
  },
);
